<template>
    <div>
        <v-container justify-start pb-0>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Roster:
                        <team-badge
                            v-bind:team="getTeamById(this.id).team"
                            v-bind:colour="getTeamById(this.id).colour"
                            width="120px"
                        ></team-badge>
                    </div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
            <v-btn flat small color="primary" right v-on:click="$router.go(-1)">Back</v-btn>
        </v-container>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12 lg9>
                    <v-card>
                        <v-data-table
                            v-bind:headers="headers"
                            v-bind:items="teamRoster"
                            v-bind:pagination.sync="pagination"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <td class="text-xs-right">{{ props.item.number }}</td>
                                <td>{{ props.item.position }}</td>
                                <td>{{ props.item.player }}</td>
                                <td v-if="props.item.spare">
                                    <v-icon>check</v-icon>
                                </td>
                                <td v-else>
                                </td>
                                <td v-if="props.item.manager">
                                    <v-icon>check</v-icon>
                                </td>
                                <td v-else>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'RostersShow',
    props: ['id'],
    data() {
        return {
            exact: true,
            headers: [
                {
                    text: 'Number',
                    align: 'right',
                    sortable: true,
                    value: 'number',
                    width: '50px'
                },
                {
                    text: 'Position',
                    align: 'left',
                    sortable: true,
                    value: 'position',
                    width: '50px'
                },
                {
                    text: 'Player',
                    align: 'left',
                    sortable: true,
                    value: 'player',
                },
                {
                    text: 'Spare',
                    align: 'left',
                    sortable: false,
                    value: 'manager',
                    width: '50px'
                },
                {
                    text: 'Manager',
                    align: 'left',
                    sortable: false,
                    value: 'manager',
                    width: '50px'
                }
            ],
            pagination: {
                rowsPerPage: -1,
                sortBy: 'player'
            }
        }
    },
    methods: {
        getTeamById(id) {
            let team_id = this.$store.getters.getRosterById(id).team_id
            return this.$store.getters.getTeamById(team_id)
        }
    },
    computed: {
        teamRoster() {
            return this.$store.getters.getTeamRoster(this.id)
        },
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
